declare var wc: any;

/**
 * Get the currrent path of the WC Admin navigation.
 *
 * @returns {function}
 */
export function getPath() {
  return wc?.navigation?.getPath() ?? "";
}
